"use strict";

import { CssCustomProperties } from "../../utility/_cssCustomProperties";
import { formValidate, submitAfterDisabled } from "../../utility/_form";

const selectWrap = () => {
  const selects = document.querySelectorAll("select");
  const classNameWrap = "select";
  const classNameInner = "select__inner";

  selects.forEach((element) => {
    const wrap = document.createElement("div");
    wrap.className = classNameWrap;

    const inner = document.createElement("div");
    inner.className = classNameInner;

    wrap.appendChild(inner);
    element.parentNode.insertBefore(wrap, element);
    inner.appendChild(element);
  });
};

const inputCheckedEvents = () => {
  const checkboxs = document.querySelectorAll(".value > span");
  checkboxs.forEach((checkbox) => {
    const input = checkbox.querySelector("input");
    const checkJudge = () => {
      if (input.checked) {
        input.checked = false;
        checkbox.classList.remove("is-checked");
      } else {
        input.checked = true;
        checkbox.classList.add("is-checked");
      }
    };

    // ロード時、既にチェックが入っていた場合
    if (input.checked) {
      checkbox.classList.add("is-checked");
    }

    checkbox.addEventListener("click", () => {
      checkJudge();
    });

    input.addEventListener("change", () => {
      checkJudge();
    });

    input.addEventListener("focus", () => {
      checkbox.classList.add("is-focused");
    });

    input.addEventListener("blur", () => {
      checkbox.classList.remove("is-focused");
    });
  });
};

const labelAddRequired = () => {
  const requireds = document.querySelectorAll("label.required");
  requireds.forEach((required) => {
    const span = document.createElement("span");
    const className = "required";
    span.className = className;

    required.appendChild(span);
  });
};

const inputAddPlaceholder = () => {
  document.querySelector(".last_name input").setAttribute("placeholder", "例）鈴木");
  document.querySelector(".first_name input").setAttribute("placeholder", "例）太郎");
  document.querySelector(".company input").setAttribute("placeholder", "例）株式会社揚羽");
  document.querySelector(".email input").setAttribute("placeholder", "例）xxxxxx.ageha.com");
  document.querySelector(".phone input").setAttribute("placeholder", "例）00-0000-0000");
  document
    .querySelector(".detail textarea")
    .setAttribute("placeholder", "お問い合わせ内容を入力して下さい(1000文字以内)");
};

const postData = (event) => {
  const target = parent.postMessage ? parent : parent.document.postMessage ? parent.document : undefined;
  const form = document.getElementById("pardot-form");
  const height = document.body.scrollHeight;
  let data = { height, validate: false };

  if (event !== undefined) {
    if (event.type === "load") {
      const validate = form.classList.contains("error") ? true : false;
      data = {
        height,
        validate,
      };
    }
  }

  if (typeof target != "undefined" && document.body.scrollHeight) target.postMessage(data, "*");
};

window.addEventListener(
  "DOMContentLoaded",
  () => {
    new CssCustomProperties();
    selectWrap();
    inputCheckedEvents();
    labelAddRequired();
    inputAddPlaceholder();
    // submitAfterDisabled();
    formValidate(postData);
  },
  false
);

window.addEventListener("load", postData, false);
window.addEventListener("change", postData, false);
window.addEventListener("resize", postData, false);
